import React from 'react';
import qs from 'qs';
import { AccountPerformanceReporting } from './AccountPerformanceReporting/AccountPerformanceReporting';
import AdvancedReports from './AdvancedReports/AdvancedReportsContainer';
import { AdviserGetStarted } from './AdviserGetStarted/AdviserGetStarted';
import AdviserSettings from './AdviserSettings/AdviserSettingsContainer';
import Alight from './Alight/AlightContainer';
import { StatusViews } from './Apex/StatusViews/StatusViews';
import Assumptions from './Assumptions/AssumptionsContainer';
import Campaigns from './CampaignsOPL/Campaigns';
import { Checkout } from './Checkout/Checkout';
import { ClientSettings } from './ClientSettings/ClientSettings';
import { ClientStartPage } from './ClientStartPage/ClientStartPage';
import { Dashboard } from './DashboardOPL/Dashboard';
import { DocumentVault } from './DocumentVault/DocumentVault';
import FatalError from './ErrorPages/FatalErrorView';
import PageNotFound from './ErrorPages/PageNotFoundView';
import NewFinancialPlan from './FinancialPlan/FinancialPlanContainer';
import FinancialPlanCapsuleWrapper from './FinancialPlanCapsuleWrapper/FinancialPlanCapsuleWrapperContainer';
import FinancialPlanWrapper from './FinancialPlanWrapper/FinancialPlanWrapperContainer';
import Leads from './Leads';
import AllWorkflowsDoneView from './MultiWorkflows/AllWorkflowsDoneView';
import DebtManagementWorkflow from './MultiWorkflows/DebtManagementWorkflow/DebtManagementWorkflowContainer';
import EducationWorkflow from './MultiWorkflows/EducationWorkflow/EducationWorkflowContainer';
import EmergencyFundWorkflow from './MultiWorkflows/EmergencyFundWorkflow/EmergencyFundWorkflowContainer';
import FinancialAccountsWorkflow from './MultiWorkflows/FinancialAccountsWorkflow/FinancialAccountsWorkflowContainer';
import HealthCareWorkflow from './MultiWorkflows/HealthcareWorkflow/HealthcareWorkflowContainer';
import HomePurchaseWorkflow from './MultiWorkflows/HomePurchaseWorkflow/HomePurchaseWorkflowContainer';
import LargePurchaseWorkflow from './MultiWorkflows/LargePurchaseWorkflow/LargePurchaseWorkflowContainer';
import RetirementWorkflow from './MultiWorkflows/RetirementWorkflow/RetirementWorkflowContainer';
import { RiskToleranceWorkflow } from './RiskToleranceWorkflow/RiskToleranceWorkflow';
import SummaryDebtManagement from './MultiWorkflows/Summaries/SummaryDebtManagement/SummaryDebtManagementContainer';
import SummaryEmergencyFund from './MultiWorkflows/Summaries/SummaryEmergencyFund/SummaryEmergencyFundContainer';
import SummaryDecumulation from './MultiWorkflows/Summaries/SummaryDecumulation/SummaryDecumulationContainer';
import SummaryHealthcare from './MultiWorkflows/Summaries/SummaryHealthcare/SummaryHealthcareContainer';
import SummaryHomePurchase from './MultiWorkflows/Summaries/SummaryHomePurchase/SummaryHomePurchaseContainer';
import SummaryRetirement from './MultiWorkflows/Summaries/SummaryRetirement/SummaryRetirementContainer';
import WorkflowDoneV2 from './MultiWorkflows/WorkflowDoneV2/WorkflowDoneV2Container';
import NetWorth from './NetWorthReport/NetWorthReportContainer';
import NoClientAccess from './NoClientAccess/NoClientAccessView';
import ConsumerOverviewComponent from './Overview/ConsumerOverviewContainer';
import PDF from './PDF/PDFContainer';
import ProfileComponent from './Profile/ProfileContainer';
import * as ProfilePages from './Profile/ProfilePages';
import ProjectedBalanceSheet from './ProjectedBalancesheet/ProjectedBalanceSheetContainer';
import ProjectedCashFlowReport from './ProjectedCashFlowReport/ProjectedCashFlowReportContainer';
import { AssetAllocationReport } from './Reports/AssetAllocation/View';
import TopNav from './TopNav/Adviser/TopNavContainer';
import ConsumerHeader from './TopNav/Consumer/TopNavContainer';
import Transactions from './Transactions/TransactionsContainer';
import { Workflow } from './Workflow/Workflow';
import { WorkflowWelcome } from './Workflow/components/WorkflowWelcome/WorkflowWelcome';
import { WorkflowDone } from './Workflow/components/WorkflowDone/WorkflowDone';
import { MoneyGuidePro } from './MoneyGuidePro/MoneyGuidePro';
import { UserActivity } from './UserActivity/UserActivity';
import { EMoney } from './EMoney/EMoney';
import { Schwab } from './Schwab/Schwab';
import { RISA } from './RISA/RISA';
import { OrionTrading } from './OrionTrading/OrionTrading';
import { DataReconciliation } from './DataReconciliation/DataReconciliation';
import { PortfolioReports } from './PortfolioReports/PortfolioReports';
import { DocumentVaultRedirect } from './DocumentVault/DocumentVault.redirect';
import { GoalPage } from './FinancialPlanOPL/Goals/GoalPage';
import { AutoAccountWorkflow } from './AutomatedAccount/AutoAccountWorkflow/AutoAccountWorkflow';
import { AutoAccountWorkflowResult } from './AutomatedAccount/AutoAccountWorkflowResult/AutoAccountWorkflowResult';
import { RetirementSideBySide } from './FinancialPlanOPL/Goals/goals/Retirement/pages/RetirementSideBySide/RetirementSideBySide';
import { AssetBucketingResults } from './FinancialPlanOPL/Goals/pages/AssetBucketingResults/AssetBucketingResults';
import { AccountOpening } from './ApexOPL/AccountOpening/AccountOpening';
import { AutoAccountAgreements } from './AutomatedAccount/AutoAccountAgreements/AutoAccountAgreements';
import { Newsfeed } from './Newsfeed/Newsfeed';
import { AssetBucketingPreview } from './AdviserSettingsOPL/tabs/AssetBucketing/AssetBucketingPreview';
import { ClientSearch } from './ClientSearch/ClientSearch';
import { PdfImportPage } from './PdfImportPage/PdfImportPage';
import { WorkflowInviteClient } from './Workflow/components/WorkflowInviteClient/WorkflowInviteClient';
import { RightCapital } from './RightCapital/RightCapital';
import { AssetBucketingEdit } from './FinancialPlanOPL/Goals/pages/AssetBucketingEdit/AssetBucketingEdit';
import { GoalsSummary } from './FinancialPlanOPL/GoalsSummary/GoalsSummary';
import BeFi20Survey from './BeFi20/Survey';
import BeFi20Output from './BeFi20/Output';
import BeFi20Overview from './BeFi20/Overview';
import { EstatePlanningWorkflowReview } from './EstatePlanningWorkflow/components/EstatePlanningWorkflowReview/EstatePlanningWorkflowReview';
import { DecumulationWorkflow } from './MultiWorkflows/DecumulationWorkflow/DecumulationWorkflow';
import PulseCheckWorkflow from './PulseCheck/Workflow';
import PulseCheckResults from './PulseCheck/Results';
import PulseCheckSetGoal from './PulseCheck/SetGoal';
import { GoalTrack } from './GoalTrack/GoalTrack';
import { ActionStepsReport } from './ActionStepsReport/ActionStepsReport';
import { CustomFormsWorkflow } from './CustomFormsWorkflow/CustomFormsWorkflow';
import { CharitableGivingWorkflow } from './CharitableGivingWorkflow/CharitableGivingWorkflow';
import { CharitableGivingWorkflowGoals } from './CharitableGivingWorkflowGoals/CharitableGivingWorkflowGoals';
import { BeFi } from './BeFi/BeFi';
import { RiskToleranceResults } from './FinancialPlanOPL/GoalsSummary/components/HighlightGoals/components/RiskTolerance/RiskToleranceResults';
import { PersonalFinanceTemplate } from './PersonalFinanceTemplate/PersonalFinanceTemplate';

const componentDictionaryMap = {
  DebtManagementWorkflow: {
    component: DebtManagementWorkflow,
  },
  AllWorkflowsDone: {
    component: AllWorkflowsDoneView,
  },
  WorkflowDoneV2: {
    component: WorkflowDoneV2,
  },
  WorkflowDoneV3: {
    component: WorkflowDoneV2,
  },
  FinancialAccountsWorkflowDone: {
    component: (props, ownProps) => <FinancialAccountsWorkflow {...props} {...ownProps} key="0" />,
  },
  RetirementWorkflowSummary: {
    component: SummaryRetirement,
  },
  RetirementWorkflow: {
    component: RetirementWorkflow,
  },
  RiskToleranceWorkflow: {
    component: RiskToleranceWorkflow,
  },
  FinancialAccountsWorkflow: {
    component: (props, ownProps) => <FinancialAccountsWorkflow {...props} {...ownProps} key="1" />,
  },
  RetirementWorkflowDone: {
    component: SummaryRetirement,
  },
  EducationWorkflowDone: {
    component: EducationWorkflow,
  },
  DebtManagementWorkflowDone: {
    component: SummaryDebtManagement,
  },
  HomePurchaseWorkflowDone: {
    component: SummaryHomePurchase,
  },
  LargePurchaseWorkflowDone: {
    component: LargePurchaseWorkflow,
  },
  EmergencyFundWorkflowDone: {
    component: SummaryEmergencyFund,
  },
  DecumulationWorkflowDone: {
    component: SummaryDecumulation,
  },
  ClientStartPage: {
    component: ClientStartPage,
  },
  ClientEditPlan: {
    component: ClientStartPage,
  },
  NewFinancialPlanWhatIfs: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <NewFinancialPlan useWhatIfsSidebar />
      </FinancialPlanWrapper>
    ),
  },
  ConsumerOverview: {
    component: (props, ownProps) => (
      <FinancialPlanCapsuleWrapper capsuleId="ActionSteps" {...props} {...ownProps}>
        <ConsumerOverviewComponent />
      </FinancialPlanCapsuleWrapper>
    ),
  },
  TasksV2: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <ActionStepsReport />
      </FinancialPlanWrapper>
    ),
  },
  AccountOpening: {
    component: AccountOpening,
  },
  Profile: {
    component: ProfileComponent,
  },
  ProfilePersonalInfo: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.PERSONAL_INFO} />
    ),
  },
  ProfileAccountsOld: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.ACCOUNTS_REACT} />
    ),
  },
  ProfileRiskTolerance: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.RISK_TOLERANCE} />
    ),
  },
  ProfileOtherAssets: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.OTHER_ASSETS} />
    ),
  },
  ProfileTaxFiling: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.TAX_FILING} />
    ),
  },
  ProfileGoals: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.GOALS} />
    ),
  },
  ProfileLinkAccounts: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.LINK_ACCOUNTS} />
    ),
  },
  ProfileInsurance: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.INSURANCE} />
    ),
  },
  ProfileExpenses: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.EXPENSES} />
    ),
  },
  ProfileIncome: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.INCOME} />
    ),
  },
  ProfileAccounts: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.ACCOUNTS_REACT} />
    ),
  },
  UserActivity: {
    component: UserActivity,
  },
  ProfileStockOptions: {
    component: (props, ownProps) => (
      <ProfileComponent {...props} {...ownProps} page={ProfilePages.STOCK_OPTIONS} />
    ),
  },
  ProjectedBalanceSheet: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <ProjectedBalanceSheet />
      </FinancialPlanWrapper>
    ),
  },
  ProjectedCashFlowReport: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <ProjectedCashFlowReport />
      </FinancialPlanWrapper>
    ),
  },
  AdvancedReports: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <AdvancedReports />
      </FinancialPlanWrapper>
    ),
  },
  Assumptions: {
    component: Assumptions,
  },
  AdvancedPDF: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <PDF />
      </FinancialPlanWrapper>
    ),
  },
  NetWorth: {
    component: NetWorth,
  },
  TopNav: {
    component: TopNav,
  },
  ConsumerHeader: {
    component: ConsumerHeader,
  },
  ClientSearch: {
    component: ClientSearch,
  },
  PdfImport: {
    component: PdfImportPage,
  },
  ClientSettings: {
    component: ClientSettings,
  },
  EducationWorkflow: {
    component: EducationWorkflow,
  },
  HomePurchaseWorkflow: {
    component: HomePurchaseWorkflow,
  },
  EmergencyFundWorkflow: {
    component: EmergencyFundWorkflow,
  },
  DecumulationWorkflow: {
    component: DecumulationWorkflow,
  },
  LargePurchaseWorkflow: {
    component: LargePurchaseWorkflow,
  },
  HealthCareWorkflowDone: {
    component: SummaryHealthcare,
  },
  HealthCareWorkflow: {
    component: HealthCareWorkflow,
  },
  Alight: {
    component: Alight,
  },
  NoClientAccess: {
    component: NoClientAccess,
  },
  AdviserSettings: {
    component: AdviserSettings,
  },
  Leads: {
    component: Leads,
  },
  Transactions: {
    component: props => {
      const currentHash = ADV.util.Router.getObjFromHash(ADV.util.getHash());
      const { accountId } = currentHash.params;
      return <Transactions {...props} key={accountId || '0'} />;
    },
  },
  Checkout: {
    component: Checkout,
  },
  GetStarted: {
    component: AdviserGetStarted,
  },
  Dashboard: {
    component: Dashboard,
  },
  AccountPerformanceReporting: {
    component: props => {
      const currentHash = ADV.util.Router.getObjFromHash(ADV.util.getHash());
      const { accountId, groupId, tabSlug } = currentHash.params;
      return <AccountPerformanceReporting {...props} key={`${groupId}-${accountId}-${tabSlug}`} />;
    },
  },
  DocumentVaultRedirect: {
    component: DocumentVaultRedirect,
  },
  DocumentVault: {
    component: DocumentVault,
  },
  Campaigns: {
    component: Campaigns,
  },
  PageNotFound: {
    component: PageNotFound,
  },
  FatalError: {
    component: FatalError,
  },
  ApexAccount: {
    component: StatusViews,
  },
  ReactAssetAllocationReport: {
    component: (props, ownProps) => (
      <FinancialPlanWrapper {...props} {...ownProps}>
        <AssetAllocationReport {...props} {...ownProps} />
      </FinancialPlanWrapper>
    ),
  },
  PortfolioReports: {
    component: PortfolioReports,
  },
  ConsumerWorkflowStart: {
    component: WorkflowWelcome,
  },
  ConsumerYouAreDone: {
    component: WorkflowDone,
  },
  MoneyGuidePro: {
    component: MoneyGuidePro,
  },
  EMoney: {
    component: EMoney,
  },
  Schwab: {
    component: Schwab,
  },
  RISA: {
    component: RISA,
  },
  OrionTrading: {
    component: OrionTrading,
  },
  DataReconciliation: {
    component: DataReconciliation,
  },
  Goal: {
    component: GoalPage,
  },
  AutoAccountWorkflow: {
    component: AutoAccountWorkflow,
  },
  AutoAccountWorkflowResults: {
    component: AutoAccountWorkflowResult,
  },
  AutoAccountAgreements: {
    component: AutoAccountAgreements,
  },
  RetirementSideBySide: {
    component: props => {
      const planIds = qs.parse(props.planIds)?.planIds || [];

      return <RetirementSideBySide {...props} planIds={planIds} />;
    },
  },
  AssetBucketingResults: {
    component: AssetBucketingResults,
  },
  AssetBucketingPreview: {
    component: AssetBucketingPreview,
  },
  AssetBucketingEdit: {
    component: AssetBucketingEdit,
  },
  Newsfeed: {
    component: Newsfeed,
  },
  WorkflowInviteClient: {
    component: WorkflowInviteClient,
  },
  RightCapital: {
    component: RightCapital,
  },
  BeFi20Workflow: {
    component: BeFi20Survey,
  },
  BeFi20Results: {
    component: BeFi20Output,
  },
  GoalsSummary: {
    component: GoalsSummary,
  },
  BeFi20Overview: {
    component: BeFi20Overview,
  },
  EstatePlanningWorkflowReview: {
    component: EstatePlanningWorkflowReview,
  },
  PulseCheckWorkflow: {
    component: PulseCheckWorkflow,
  },
  PulseCheckResults: {
    component: PulseCheckResults,
  },
  PulseCheckSetGoal: {
    component: PulseCheckSetGoal,
  },
  GoalTrack: {
    component: GoalTrack,
  },
  CustomFormsWorkflow: {
    component: CustomFormsWorkflow,
  },
  CharitableGivingWorkflow: {
    component: CharitableGivingWorkflow,
  },
  CharitableGivingWorkflowGoals: {
    component: CharitableGivingWorkflowGoals,
  },
  BeFi: {
    component: BeFi,
  },
  RiskToleranceResults: {
    component: RiskToleranceResults,
  },
  PersonalFinanceTemplate: {
    component: PersonalFinanceTemplate,
  },
};

const comprehensiveWorkflow = {
  Workflow: {
    component: (props, ownProps) => (
      <Workflow {...props} {...ownProps} componentDictionaryMap={componentDictionaryMap} />
    ),
  },
};

export default {
  ...componentDictionaryMap,
  ...comprehensiveWorkflow,
};
